"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCustomDesignStore = void 0;
/* eslint-disable no-useless-catch */
/* eslint-disable no-undef */
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const PermissionEnum_1 = require("../../models/permission/PermissionEnum");
exports.useCustomDesignStore = (0, pinia_1.defineStore)("customDesignStore", {
    state: () => ({
        loading: false,
        currentColor: '',
        filePath: '',
        isCustomPriceViewActive: false,
        marsoLogoPath: require("../../images/marso-logo-fekvo.svg"),
        marsoLogoAlt: "MARSO logo",
        marsoRed: "#DC2F33"
    }),
    actions: {
        // A store inicializálása a user jogosultsága(i) alapján.
        initializeStore(authenticatedUser) {
            if (!authenticatedUser)
                return;
            // Ha van a usernek "CUSTOMER_PRICING_READ" jogosultsága, akkor beállítjuk megfelelően a "customPriceViewActive" értékét.
            if (authenticatedUser.hasPermission(PermissionEnum_1.CustomerPricingPermissionEnum.CUSTOMER_PRICING_READ)) {
                this.isCustomPriceViewActive = JSON.parse(localStorage.getItem("isCustomPriceViewActive") || "false");
            }
        },
        async toggleCustomPriceView(currentUser, value) {
            this.isCustomPriceViewActive = value;
            localStorage.setItem("isCustomPriceViewActive", JSON.stringify(value));
            if (this.isCustomPriceViewActive) {
                await this.setDesign(currentUser);
            }
            else {
                this.resetDesign();
            }
        },
        async getDesign(currentUser) {
            this.loading = true;
            try {
                const customer = await (0, fetch_1.default)(`/api/customers/${currentUser.customer.id}`);
                if (customer["@type"] === "Customer") {
                    this.currentColor = customer.pageColor || this.marsoRed;
                    const path = `/files/custom-design/logos/logo-${currentUser.customer.id}.png?${Date.now()}`;
                    const exists = await this.checkLogoPath(path);
                    this.filePath = exists ? path : '';
                }
            }
            catch (error) {
                throw error;
            }
            finally {
                this.loading = false;
            }
        },
        async checkLogoPath(path) {
            this.loading = true;
            try {
                const response = await fetch(path);
                return response.ok;
            }
            catch {
                return false;
            }
            finally {
                this.loading = false;
            }
        },
        async saveDesign(router, request, customerId) {
            this.loading = true;
            const options = { body: JSON.stringify(request), method: 'POST' };
            try {
                await (0, fetch_1.default)(router.resolve({ name: 'save_design_api', params: { id: customerId } }).href, options);
            }
            catch (error) {
                throw error;
            }
            finally {
                this.loading = false;
            }
        },
        async removeDesign(router, request, customerId) {
            this.loading = true;
            const options = { body: JSON.stringify(request), method: 'POST' };
            try {
                await (0, fetch_1.default)(router.resolve({ name: 'remove_design_api', params: { id: customerId } }).href, options);
            }
            catch (error) {
                throw error;
            }
            finally {
                this.loading = false;
            }
        },
        async readFileAsBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    const result = reader.result;
                    if (typeof result === 'string') {
                        resolve(result);
                    }
                };
                reader.onerror = (error) => reject(error);
            });
        },
        async setDesign(currentUser, getDesign = true) {
            // A design lekérdezése csak akkor történik meg, ha a getDesign értéke true.
            // Ez pélául a design tesztelésnél fontos, hogy ne adatbázisból kérje le a design-t.
            if (getDesign) {
                await this.getDesign(currentUser);
            }
            const navbars = document.querySelectorAll(".navbar");
            const navbarImages = Array.from(navbars)
                .map(navbar => navbar.querySelector("a > img"));
            const footer = document.querySelector(".footer");
            navbars.forEach((navbar, index) => {
                var _a;
                const navElement = navbar;
                navElement.classList.remove("bg-red");
                navElement.style.backgroundColor = this.currentColor;
                const img = navbarImages[index];
                if (img) {
                    if (this.filePath) {
                        img.setAttribute("src", this.filePath);
                        img.setAttribute("alt", "logo");
                    }
                    else {
                        (_a = img.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(img);
                        if (!navbar.hasAttribute("data-div-inserted")) {
                            const div = document.createElement("div");
                            div.textContent = String(currentUser.customer.name);
                            const firstAnchor = navbar.querySelector("a");
                            if (firstAnchor) {
                                firstAnchor.appendChild(div);
                                navbar.setAttribute("data-div-inserted", "true");
                            }
                        }
                    }
                }
            });
            if (footer) {
                footer.classList.remove("border-red");
                footer.style.borderColor = this.currentColor;
            }
        },
        resetDesign() {
            const navbars = document.querySelectorAll(".navbar");
            const footer = document.querySelector(".footer");
            navbars.forEach(navbar => {
                var _a;
                const navElement = navbar;
                navElement.style.removeProperty("background-color");
                navElement.classList.add("bg-red");
                const div = navbar.querySelector("a > div");
                if (div) {
                    (_a = div.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(div);
                    navbar.removeAttribute("data-div-inserted");
                }
                const anchor = navbar.querySelector("a");
                if (anchor) {
                    const img = anchor.querySelector("img");
                    if (!img) {
                        const img = document.createElement('img');
                        img.setAttribute("src", this.marsoLogoPath);
                        img.setAttribute("alt", this.marsoLogoAlt);
                        anchor.appendChild(img);
                    }
                    else {
                        img.setAttribute("src", this.marsoLogoPath);
                        img.setAttribute("alt", this.marsoLogoAlt);
                    }
                }
            });
            if (footer) {
                footer.style.removeProperty("border-color");
                footer.classList.add("border-red");
            }
        }
    }
});
